import { useState } from 'react';

import {
  AdminEnterprisesWithLicenseScreenDocument,
  AdminEnterprisesWithoutLicenseScreenDocument,
  EnterpriseLicenseEditor_CompanyFragment,
} from '@/graphql/generated';
import licensingApi from '@/slices/licensing/licensing.api';

import { Checkbox } from '@/components/form/Checkbox';
import { Loader } from '@/components/generic/Loader';
import { useToast } from '@/components/layout/Toast';
import { useApolloRefetcher } from '@/hooks/useApolloRefetcher';
import { useTranslation } from '@/hooks/useTranslation';

export function EnterpriseLicenseEditor({
  company,
}: {
  company: EnterpriseLicenseEditor_CompanyFragment;
}) {
  const toast = useToast();
  const { t } = useTranslation();
  const { callRefetchQueries } = useApolloRefetcher();

  const [hasLicense, setHasLicense] = useState<boolean>(
    (company.license?.licensesCount && company.license?.licensesCount > 0) ||
      false,
  );

  const toggleHasLicense = (newHasLicense: boolean) => {
    setHasLicense(newHasLicense);
    saveLicenseCount(newHasLicense ? 1 : 0);
  };

  const [updateCompanyLicense, { isLoading }] =
    licensingApi.endpoints.updateCompanyLicense.useMutation();

  const saveLicenseCount = (licensesCount: number | null) => {
    updateCompanyLicense({
      companyId: company.id,
      licensesCount: licensesCount ?? 0,
    })
      .unwrap()
      .then(() => {
        toast.openToastWithMessage(t('admin:companies.toast.limit_updated'));
        callRefetchQueries([
          AdminEnterprisesWithLicenseScreenDocument,
          AdminEnterprisesWithoutLicenseScreenDocument,
        ]);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  return (
    <div className="flex items-center gap-2">
      <label className="form-input-label">
        {t('admin:companies.list.item.has_license')}
      </label>
      {isLoading ? (
        <Loader />
      ) : (
        <Checkbox
          onClick={() => toggleHasLicense(!hasLicense)}
          checked={hasLicense}
        />
      )}
    </div>
  );
}
